export default __webpack_public_path__ + "static/media/LightArrowDropdown.52f7b280.svg";